module.exports = __webpack_public_path__ + "static/media/marclaros.74cd65ff.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/marclaros.webp
// module id = 893
// module chunks = 0